import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-csc-stats',
  templateUrl: './csc-stats.component.html',
  styleUrls: ['./csc-stats.component.css']
})
export class CscStatsComponent implements OnInit {
  images = [
    {imgName: 'Years of Service', imgPath: '../../../../assets/img/stats/years_of_service.png'},
    {imgName: '48+ Branches Nationwide', imgPath: '../../../../assets/img/stats/branch_locations.png'},
    {imgName: '200+ Cities Served', imgPath: '../../../../assets/img/stats/cities_served.png'},
    {imgName: 'Trained Team Members', imgPath: '../../../../assets/img/stats/team_members.png'},
    {imgName: 'Millions of Patrons Served Annually', imgPath: '../../../../assets/img/stats/patrons_served_annually.png'}
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
